module.exports = __webpack_public_path__ + "img/bills.d9d6d0ef.svg";